import * as React from 'react';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormHelperText from '@mui/material/FormHelperText';
import FormControl from '@mui/material/FormControl';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import { SxProps } from '@mui/material';


export default function SelectLiquidacion({ value, label, onChange, sx, size }: { value?: boolean, label?: string, onChange: (value?: boolean) => void, sx?: SxProps<any>, size?: 'small' | 'medium' }) {


    const getValue = () => {
        if (value === true) {
            return 'true';
        }
        if (value === false) {
            return 'false';
        }
        return undefined
    }

    return (
        <FormControl sx={{ minWidth: 120 }} size={size}>
            <Select
                sx={sx}
                size={size}
                value={getValue()}
                placeholder={label}
                onChange={(event: SelectChangeEvent) => {
                    onChange(
                        event.target.value === 'true' ? true :
                            event.target.value === 'false' ? false :
                                undefined)
                }}
                displayEmpty

            >
                <MenuItem value={undefined}
                    sx={{
                        fontStyle: 'italic'
                    }}
                >
                    <em style={{ color: 'gray' }}>liquidación</em>
                </MenuItem>
                <MenuItem value='true'>Liquidado</MenuItem>
                <MenuItem value='false'>No liquidado </MenuItem>
            </Select>
        </FormControl >
    );
}
